module.exports = __webpack_public_path__ + "static/media/filter_black_rich.3faef328.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/filter_black_rich.svg
// module id = 347
// module chunks = 0